import axios from "axios";
import {
  FETCH_CLIENTES_REQUEST,
  FETCH_CLIENTES_SUCCESS,
  FETCH_CLIENTES_FAILURE,
} from "./types";
import { PATH } from "../../utils";

const api = axios.create({
  baseURL: PATH,
  headers: { "Content-Type": "application/json" },
});

const authHeader = () => {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const actionClientesGet = (params = {}) => async (dispatch) => {
  dispatch({ type: FETCH_CLIENTES_REQUEST });
  try {
    const cleanParams = Object.fromEntries(
      Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== "")
    );
    const res = await api.get("/clientes", { headers: authHeader(), params: cleanParams });
    const items = Array.isArray(res.data) ? res.data : res.data?.items ?? [];
    dispatch({ type: FETCH_CLIENTES_SUCCESS, payload: items });
  } catch (err) {
    const msg = err?.response?.data?.detail || err.message || "Error al cargar clientes";
    dispatch({ type: FETCH_CLIENTES_FAILURE, payload: { error: msg } });
  }
};

export const apiClientesInstance = api;
export { authHeader as authHeaderClientes };
